import { isDouyinAppChannel } from './code';

const canUseLocalStorage = typeof localStorage !== undefined;

export const TIKTOK_USER_OPEN_ID_STORAGE_KEY = 'TIKTOK_USER_OPEN_ID_STORAGE_KEY';

export const setUserOpenIdForTiktok = (openId?: string) => {
  if (isDouyinAppChannel() && canUseLocalStorage) {
    localStorage.setItem(TIKTOK_USER_OPEN_ID_STORAGE_KEY, openId || '');
  }
};

export const getUserOpenIdForTiktok = () => {
  if (isDouyinAppChannel() && canUseLocalStorage) {
    const _id = localStorage.getItem(TIKTOK_USER_OPEN_ID_STORAGE_KEY);
    return _id || undefined;
  }
  return undefined;
};
